import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "contexts/AuthContext";
import AppLayout from "components/layout/AppLayout";
import Login from "pages/Login";
import OidcCallback from "pages/OidcCallback";
import PublicHome from "pages/PublicHome";
import PublicScan from "pages/PublicScan";
import Search from "pages/Search";
import Dorks from "pages/Dorks";
import HostDetail from "pages/HostDetail";
import CertDetail from "pages/CertDetail";
import DomainDetail from "pages/DomainDetail";
import Tokens from "pages/Tokens";
import Dashboard from "pages/admin/Dashboard";
import Buckets from "pages/admin/Buckets";
import OpenSearchConfig from "pages/admin/OpenSearchConfig";
import OpenSearchForm from "pages/admin/OpenSearchForm";
import Users from "pages/admin/Users";
import UserForm from "pages/admin/UserForm";
import Crawlers from "pages/admin/Crawlers";
import CrawlerForm from "pages/admin/CrawlerForm";

export default function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso/callback" element={<OidcCallback />} />
          <Route path="/landing" element={<PublicHome />} />
          <Route path="/scan" element={<PublicScan />} />

          {/* rotas autenticadas — layout único (igual ao sec_attendant) */}
          <Route element={<AppLayout darkMode={darkMode} setDarkMode={setDarkMode} />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/search" element={<Search />} />
            <Route path="/dorks" element={<Dorks />} />
            <Route path="/host/:ip" element={<HostDetail />} />
            <Route path="/certificate/:thumbprint" element={<CertDetail />} />
            <Route path="/domain/:domain" element={<DomainDetail />} />
            <Route path="/tokens" element={<Tokens />} />
            <Route path="/admin/opensearch" element={<OpenSearchConfig />} />
            <Route path="/admin/opensearch/new" element={<OpenSearchForm />} />
            <Route path="/admin/opensearch/:id/edit" element={<OpenSearchForm />} />
            <Route path="/admin/buckets" element={<Buckets />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/users/new" element={<UserForm />} />
            <Route path="/admin/users/:id/edit" element={<UserForm />} />
            <Route path="/admin/crawlers" element={<Crawlers />} />
            <Route path="/admin/crawlers/new" element={<CrawlerForm />} />
            <Route path="/admin/crawlers/:id/edit" element={<CrawlerForm />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
